import AuthService from "../auth/AuthService";
import hbscan from "../../api/hbscan";
import { IInOutScanOverride } from "../../models/inOutScanOverride";

class InOutScanOverrideService {
  Upsert = async (data: IInOutScanOverride) => {
    const URI = `/api/hbscan/InOutScanOverride/UpsertInOutScanOverride`;

    return (
      await hbscan.post<void>(URI, data, {
        headers: { Authorization: AuthService.guid }
      })
    ).data;
  };

  Delete = async (params: { userId: number; inOutCode: string; originalTimestamp: Date }) => {
    const URI = `/api/hbscan/InOutScanOverride/DeleteInOutScanOverride`;
    const { userId, inOutCode, originalTimestamp } = params;

    return (
      await hbscan.delete<void>(URI, {
        headers: { Authorization: AuthService.guid },
        params: { userId, inOutCode, originalTimestamp }
      })
    ).data;
  };

  GetByCompany = async (start: Date, end: Date) => {
    const URI = `/api/hbscan/InOutScanOverride/GetInOutScanOverridesByCompany`;

    return (
      await hbscan.get<IInOutScanOverride[]>(URI, {
        headers: { Authorization: AuthService.guid },
        params: { start, end }
      })
    ).data;
  }
}

const inOutScanOverrideService = new InOutScanOverrideService();

export default inOutScanOverrideService;